import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useNavigation } from '../context/NavigationContext';
import { useNavigationHandler } from '../utils/navigation';
import './Navbar.css';

function Navbar() {
  const { activePage, clickedPage } = useNavigation();
  const { handleNavClick } = useNavigationHandler();
  const location = useLocation();
  const isCaseStudy = location.pathname.includes('/case-study/');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileNavClick = (page) => {
    handleNavClick(page);
    setIsMobileMenuOpen(false); // Close menu after navigation
  };

  const getButtonClass = (page) => {
    // Use clickedPage if it exists, otherwise fall back to activePage
    const isActive = clickedPage ? clickedPage === page : activePage === page;
    // Don't mark any nav button as active when viewing a case study
    return `nav-button ${isActive && !isCaseStudy ? 'nav-button-active' : ''}`;
  };

  return (
    <nav className="navbar">
      <Link to="/" className="nav-brand" onClick={() => handleNavClick('home')}>
        <div className="brand-mask">
          <div className="brand-line">
            <div className="brand-text-top">Robin Gardeur (le Shka)</div>
            <div className="brand-text-bottom">Robin Gardeur (le Shka)</div>
          </div>
        </div>
      </Link>
      
      {/* Desktop Navigation */}
      <ul className="nav-links desktop-nav">
        <li><Link to="/work" className={getButtonClass('work')} onClick={() => handleNavClick('work')}>Case studies</Link></li>
        <li><Link to="/about" className={getButtonClass('about')} onClick={() => handleNavClick('about')}>About</Link></li>
        <li><Link to="/snippets" className={getButtonClass('snippets')} onClick={() => handleNavClick('snippets')}>Snippets</Link></li>
      </ul>

      {/* Mobile Hamburger Menu */}
      <button 
        className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span className="hamburger-line"></span>
        {/* <span className="hamburger-line"></span> */}
        <span className="hamburger-line"></span>
      </button>

      {/* Mobile Navigation Menu */}
      <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-links">
          <li><Link to="/work" className={getButtonClass('work')} onClick={() => handleMobileNavClick('work')}>Case studies</Link></li>
          <li><Link to="/about" className={getButtonClass('about')} onClick={() => handleMobileNavClick('about')}>About</Link></li>
          <li><Link to="/snippets" className={getButtonClass('snippets')} onClick={() => handleMobileNavClick('snippets')}>Snippets</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;